<template>
    <app-layout>
        <row class="mt-6">
            <column md="4">
                <card>
                    <div class="d-flex justify-content-center">
                        <icon
                            class="profile-placeholder mt-3 mx-5 mb-4"
                            icon="cil-user"
                        />
                    </div>
                    <div
                        class="d-flex justify-content-between align-items-center"
                    >
                        <h4 class="mb-0">{{ user.name }}</h4>
                        <div>
                            <role-badge
                                v-for="role in user.roles"
                                :key="role.id"
                                :role="role"
                            />
                        </div>
                    </div>
                    <email-link :email="user.email" size="sm" />
                    <div class="mt-5">
                        <h5>{{ trans('users.show.airports.header') }}</h5>
                        <ul v-if="locations" class="list-unstyled">
                            <li
                                v-for="location in locations"
                                :key="location.id"
                                class="d-flex justify-content-start align-items-start mb-2"
                            >
                                <div>
                                    <icon
                                        v-if="location.countryCodeAlpha2"
                                        v-c-tooltip="{
                                            content: location.countryCodeAlpha2,
                                        }"
                                        :name="
                                            'cif-' +
                                            location.countryCodeAlpha2.toLowerCase()
                                        "
                                        size="xl"
                                    />
                                </div>
                                <div class="mx-2">{{ location.name }}</div>
                                <div class="text-muted">
                                    ({{ location.icaoCode }})
                                </div>
                            </li>
                        </ul>
                        <div v-else>
                            {{ trans('users.show.airports.empty') }}
                        </div>
                    </div>
                    <template #footer>
                        <div
                            v-if="
                                hasAnyPermission(['user.index', 'user.update'])
                            "
                            class="d-flex justify-content-center"
                            style="gap: 10px"
                        >
                            <jet-button
                                type="button"
                                variant="tertiary"
                                @click.stop="
                                    $inertia.visit($route('users.index'))
                                "
                                >{{ trans('general.action.cancel') }}
                            </jet-button>
                            <jet-button
                                v-if="hasAnyPermission(['user.update'])"
                                type="button"
                                @click.stop="
                                    $inertia.visit(
                                        $route('users.edit', user.id),
                                    )
                                "
                                >{{ trans('general.action.edit') }}
                            </jet-button>
                        </div>
                    </template>
                </card>
            </column>
            <column md="8">
                <activity-log
                    v-if="hasAnyPermission(['user.activity.read'])"
                    :activities="activities"
                    :fields="fields"
                    :query-params="activeQueryParams"
                    context="user"
                />
            </column>
        </row>
    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import RoleBadge from '@/Components/RoleBadge.vue';
import Pagination from '@/Components/Pagination.vue';
import ActivityLog from '@/Components/ActivityLog/ActivityLog.vue';

import Card from '@/Components/Card.vue';
import EmailLink from '@/Components/EmailLink.vue';
import JetButton from '@/Jetstream/Button.vue';
import { usePage } from '@inertiajs/vue3';
import useQueryParams from '@/Utils/UseQueryParams';

export default {
    components: {
        JetButton,
        EmailLink,
        Card,

        AppLayout,
        ActivityLog,
        Pagination,
        RoleBadge,
    },

    setup() {
        const page = usePage();
        const activeQueryParams = useQueryParams({
            paramsWithDefaults: {
                sort: { column: 'date', asc: false },
            },
            route: route('users.show', page.props.user),
            options: {
                only: ['activities'],
            },
        });

        return {
            activeQueryParams,
        };
    },

    data() {
        return {
            changes: null,
            fields: [
                {
                    key: 'date',
                    label: this.trans('activities.overview.cell.date'),
                },
                {
                    key: 'event',
                    label: this.trans('activities.overview.cell.event'),
                    sorter: false,
                },
            ],
        };
    },

    computed: {
        user() {
            return this.$page.props.user;
        },
        activities() {
            return this.$page.props.activities;
        },
        locations() {
            return this.user.locations;
        },
    },

    methods: {
        getMailLink(email) {
            return 'mailto:' + email;
        },
    },
};
</script>
<style scoped>
.profile-placeholder {
    display: block;
    width: 50% !important;
    height: auto !important;
}
</style>
